
import { defineComponent } from "vue";

import Dialog from "primevue/dialog";
import MapCustom from "@/components/MapCustom.vue";
import { Coordinates, Marker } from "@/typings/Marker";
import { QueryParameters } from "@/typings/QueryParameters";
import { Stop } from "@/typings/Stop";

export default defineComponent({
  data: () => ({
    showMap: false,
    center: { lat: 45.91831, lng: 14.229618 } as Coordinates,
    zoom: 15,
    markers: [] as Marker[],
  }),
  methods: {
    openMap() {
      this.loadStations();
      this.showMap = true;
    },
    closeMap() {
      this.showMap = false;
    },
    updateCenter(value: Coordinates) {
      this.center = value;
      this.loadStations();
    },
    updateZoom(value: number) {
      this.zoom = value;
      this.loadStations();
    },
    loadStations() {
      let params: QueryParameters & {
        latitude?: number;
        longitude?: number;
        radius?: number;
      } = {
        orderBy: {
          name: "ASC",
        },
      };

      if (this.center !== null) {
        params.latitude = this.center.lat;
        params.longitude = this.center.lng;
        params.radius = Math.pow(2, 27 - this.zoom);
      }
      let cityId = window.VUE_APP_CITY_ID || process.env.VUE_APP_CITY_ID;
      let url = "api/v1/public-transport/" + cityId + "/stops";
      this.$http.get(url, { params }).then((response) => {
        let stationArray = response.data.data as Stop[];
        this.markers = stationArray.map((station) => ({
          id: station.id,
          position: {
            lat: parseFloat(station.latitude),
            lng: parseFloat(station.longitude),
          },
          on_click_route_name: "StationById",
          type: "station",
        }));
      });
    },
  },
  components: { MapCustom, Dialog },
});
